import React from 'react';
import AppHeader from '../../../components/appbar/AppBar';
import ThankYou from './Thankyou';
const PosThankyou = () => {
  return (
    <div className="h-full">
      <div className="bg-blue_three">
        <AppHeader bgColor="transparent" />
      </div>
      <ThankYou />
    </div>
  );
};
export default PosThankyou;
